<script>
export default {

    computed: {

        chartOptions: function () {
            return {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            max: 100,
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false,
                height: 400,
                maxBarThickness: 30,
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: '% Diverted from Landfill'
                },
                tooltips: {
                    enabled: false
                }
            }
        },

        wasteStreamsChartOptions () {
            return {
                title: {
                    display: true,
                    text: 'Waste Streams %'
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    enabled: false
                }
            }
        },

        materialsChartOptions () {
            return {
                title: {
                    display: true,
                    text: 'Materials %'
                },
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    enabled: false
                }
            }
        }

    },

    methods: {

        analysisChartData (chartData, valueKey) {
            let labels = []
            let data = []
            let backgroundColor = []

            for (let row in chartData) {
                if (chartData[row].hasOwnProperty(valueKey)) {
                    labels.push(chartData[row].label)
                    data.push(chartData[row][valueKey])

                    if (chartData[row].hasOwnProperty('background')) {
                        backgroundColor.push(chartData[row]['background'])
                    }
                }
            }

            return {
                labels: labels,
                datasets: [
                    {
                        data,
                        backgroundColor,
                        hoverBackgroundColor: backgroundColor,
                        borderWidth: 0,
                        hoverBorderWidth: 0,
                    }
                ],
            }
        },

    }

}
</script>
